/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.7.7
 */
import Tool from './Tool'
import PathMarker from '@/marker/PathMarker'
//
/**
 * 点图元绘制工具
 */
export default class PointTool extends Tool {
  options = { feature: { src: 'circle', color: '#000', radius: 5, fillColor: '#FFF', weight: 1, fillOpacity: 1 } }
  /**
   * 启动
   */
  start() {
    //
    this.onMouseDown = this.onMouseDown.bind(this)
    //
    // this.map.once('mousedown', this.onMouseDown);
    // this.map.once('mouseup', this.onEnd);
    //
    this.map.on('mousedown', this.onMouseDown);
  }
  /**
   * 取消
   */
  cancel() {
    this.map.off('mousedown', this.onMouseDown);
  }
  /**
   * 绘制-start
   * @param e 
   */
  onMouseDown(e) {
    let { latlng } = e;
    let { options, layer, marker } = this;
    if (marker) {
      marker.setLatLng(latlng);
    } else {
      this.marker = new PathMarker(latlng, options.feature).addTo(layer);
    }
    this.onEnd();
  }
}


// WEBPACK FOOTER //
// ./src/plugins/tools/PointTool.js